export type CareerContentSource = "local" | "backend";

function resolveContentSource(): CareerContentSource {
    const configured = import.meta.env.VITE_CAREER_CONTENT_SOURCE?.trim();
    if (configured === undefined || configured === "") {
        return import.meta.env.DEV ? "local" : "backend";
    }
    if (configured !== "local" && configured !== "backend") {
        throw new Error(
            "VITE_CAREER_CONTENT_SOURCE must be either local or backend.",
        );
    }
    if (import.meta.env.PROD && configured === "local") {
        throw new Error(
            "Local Career content is development-only; production builds must use backend content.",
        );
    }
    return configured;
}

export const CAREER_CONTENT_SOURCE = resolveContentSource();
